import React from "react";

/**
 * Edge-to-edge horizontal marquee strip. Items repeat infinitely.
 * Pause on hover. Reverses direction in RTL.
 *
 * Sizes:
 *   thin → ~46-56px tall (used for tag-strip aesthetic)
 *   md   → ~64-80px
 *   lg   → ~96-128px
 *   xl   → ~120-180px
 */
export default function Marquee({
  items = [],
  speed = "normal",          // "slow" | "normal" | "fast"
  variant = "pink",          // "pink" | "ink" | "outline"
  size = "thin",             // "thin" | "md" | "lg" | "xl"
  separator = "●",           // string OR React node
  className = "",
}) {
  const speedClass =
    speed === "fast" ? "[animation-duration:14s]" :
    speed === "slow" ? "[animation-duration:40s]" :
    "[animation-duration:24s]";

  const sizeClass =
    size === "xl" ? "text-[clamp(3rem,8vw,7rem)] py-3" :
    size === "lg" ? "text-[clamp(2rem,5vw,4rem)] py-2.5" :
    size === "md" ? "text-[clamp(1.25rem,3vw,2rem)] py-2" :
    /* thin */     "text-[clamp(0.95rem,1.4vw,1.25rem)] py-2";

  const variantClass =
    variant === "ink"
      ? "bg-ink text-cream"
      : variant === "outline"
      ? "bg-cream text-ink border-y-2 border-ink"
      : "bg-brand-pink text-cream";

  // Duplicate items twice for the seamless wrap
  const list = [...items, ...items];

  return (
    <div
      className={`relative overflow-hidden ${variantClass} ${className}`}
      data-testid="marquee-strip"
      aria-hidden="true"
    >
      <div
        className={`flex w-max items-center gap-8 sm:gap-10 font-display font-extrabold uppercase tracking-tight whitespace-nowrap animate-marquee-x ${speedClass} ${sizeClass} hover:[animation-play-state:paused]`}
      >
        {list.map((it, i) => (
          <span key={i} className="inline-flex items-center gap-8 sm:gap-10">
            <span>{it}</span>
            <span className="text-current opacity-70 inline-flex items-center">
              {separator}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
